__turbopack_context__.v({
  "redirectHome": "RedirectHome-module-scss-module__fr9cMq__redirectHome",
});
